<template>
    <div >
        <div class="topic-label">
            <span class="label-type">{{ setQuestionType(item) }}</span>
            <div class="label-tit">{{ item.questionContent }}</div>
        </div>
        <div class="fill-area"> 
            <el-input
                v-model="fillAnswer"
                placeholder="请输入答案"
                clearable
                type="textarea"
                :disabled="submitted"
                :rows="4" 
                show-word-limit
            /> 
        </div> 
        <div class="item-answer" >
            <el-button type="primary" @click="submit(item)"  :disabled="submitted">查看答案</el-button>
        </div>
        
        
    </div>
</template>

<script> 

import { getQuestionTypeLabel } from './topicQuestionTypes.js'; 
export default {
    name: 'TopicAnswerFill',
    props: {
        item: { type: Object, required: true },
    },
    components:{ 
    },
    data(){
        return {
            submitted:false,
            fillAnswer:'', 
        }
    },

    methods: {
        setQuestionType: getQuestionTypeLabel,
        submit(){
            this.submitted=true;
            this.$emit('submitAnswer',{
                id:this.item.id,
                answer:this.fillAnswer.trim(),
                questionFlag:'',
            })
        }
    }
};
</script>

<style lang="less" scoped>

@import './topic-info.less'; 
</style>
